var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8198 4.00097L19.9998 4.00131C21.0998 4.0014 21.9998 4.90148 21.9997 6.00148L21.9985 20.0015C21.9984 21.1015 21.0984 22.0014 19.9984 22.0013L5.99836 22.0002C5.85836 22.0002 5.72836 21.9901 5.59836 21.9701C5.20837 21.8901 4.85839 21.6901 4.58841 21.42C4.40842 21.23 4.25844 21.02 4.15846 20.78C4.05848 20.54 3.9985 20.27 3.99852 20L3.99967 6C3.9997 5.72 4.05972 5.46 4.15974 5.23001C4.25975 4.99002 4.40977 4.77003 4.58979 4.59005C4.85981 4.32007 5.20983 4.1201 5.59983 4.04013C5.72984 4.01014 5.85984 4.00015 5.99984 4.00016L10.1798 4.00051C10.5999 2.84054 11.7 2.00063 13 2.00074C14.3 2.00084 15.3999 2.84093 15.8198 4.00097ZM7.99934 10.0003L7.99951 8.00033L17.9995 8.00115L17.9993 10.0011L7.99934 10.0003ZM17.999 14.0011L17.9992 12.0011L7.99918 12.0003L7.99902 14.0003L17.999 14.0011ZM14.9989 16.0009L7.99885 16.0003L7.99869 18.0003L14.9987 18.0009L14.9989 16.0009ZM12.9999 3.75074C13.4099 3.75077 13.7498 4.0908 13.7498 4.5008C13.7498 4.9108 13.4097 5.25077 12.9997 5.25074C12.5897 5.2507 12.2498 4.91068 12.2498 4.50068C12.2498 4.09068 12.5899 3.7507 12.9999 3.75074ZM5.99852 20.0002L19.9985 20.0013L19.9997 6.00131L5.99967 6.00016L5.99852 20.0002Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment24Px);
export default __webpack_public_path__ + "static/media/assignment_24px.0b430b1c89f4d7343cad191b94119af3.svg";
export { ForwardRef as ReactComponent };